import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { switchMapTo } from 'rxjs/operators';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import { last } from 'rxjs/operator/last';

export interface AuthUser {
    email: string;
    password: string;
}

export interface ForgotPassUser {
    email: string;
}

export interface CreateNewUser {
    name: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    id: string;
}

@Injectable()
export class AuthService {
    superadmin;

    auth;
    
    private getInitialUser() {
        try {
            return JSON.parse(localStorage.getItem('AUTH_USER') || 'null') || undefined;
        } catch (e) {
            return undefined;
        }
    }
    public AUTH_USER_SOURCE = new BehaviorSubject<any>(this.getInitialUser());
    changeAUTH_USER(obj){ 
        if (obj) {
            localStorage.setItem('AUTH_USER', JSON.stringify(obj));
        } else {
            localStorage.removeItem('AUTH_USER');
        }
        this.AUTH_USER_SOURCE.next(obj); 
    }

    constructor(
        public afAuth: AngularFireAuth,
        private router: Router
    ) {
        this.auth = firebase.auth();
        this.SA();
    }

    get currentUser(){
        let {name='', lastName=''} = this.AUTH_USER_SOURCE.value || {};
        return name ? {
            fullName: `${name} ${lastName}`,
            ...this.AUTH_USER_SOURCE.value
        } : undefined;
    }


    signOut() {
        this.changeAUTH_USER(undefined);
        this.auth.signOut();
        this.router.navigate(['/login']);
    }

    cLogin(cEmail, cPassword){
        return this.auth.signInWithEmailAndPassword(cEmail, cPassword);
    }

    //Uncomment for localhost
    SA(){
        /*
        this.superadmin = {
           email: "oliver.bahador.gr@gmail.com",
           //email: "patricia.lopez@mobilepro.mx",
           groups: ["VaMqegkBvD0NELZ0wTzl"],
           id: "UjvpTyuKnW9PGRdibpaa", //agro
           initials: "SOB",
           lastName: "Bahador",
           name: "Oliver"
       };
       this.changeAUTH_USER(this.superadmin);
        //let p = '644644'; this.cLogin(p + p + '@mp.com', p);
        */
    }


}
